module.exports = __webpack_public_path__ + "img/xg.aeb33d19.png";